//importing Components
import { Search } from "../../components/global/search";
import { SecondNav } from "../../components/second-nav";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import HeadTitle from "../../components/global/HeadTitle";
import { BlockBtn } from "../../components/global/btns/btns";
import { EnvloIcon, LocationIcon, PhoneIcon } from "../../components/svg";

//import assets
import Pic from "../../Assets/images/ahmedEldesoky.png";
import Logo from "../../Assets/logos/logo.svg";
import { TextBox } from "./textbox";

const Chat = () => {
  return (
    <div className="support">
      <ContactList />
      <ChatBox />
      <ContactInfo />
    </div>
  );
};

const ContactList = () => {
  const [active, setActive] = useState("all");
  return (
    <div className="support__contact-list">
      <SecondNav from="support" active={active} setActive={setActive} />
      <div className="mb__small" />
      <Search />
      <div className="mb__small" />
      <MessagesContainer />
    </div>
  );
};

const ChatBox = () => {
  const [selectOption, setSelectOption] = useState("");

  const handleOption = (e) => {
    // console.log(e.target.textContent);
    setSelectOption(e.target.textContent);
  };

  return (
    <div className="support__chat-box">
      <div className="chat-box">
        <div className="row-flex">
          <div className="message__box-img">
            <img src={Logo} alt="" className="chat-box__img" />
          </div>
          <p className="chat-box__text">مرحبا بك كيف يمكنني مساعدتك !</p>
          <p className="text--gray">4:15</p>
        </div>
        <div className="row-flex">
          <div className="message__box-img">
            <img src={Logo} alt="" className="chat-box__img" />
          </div>
          <p className="chat-box__text">
            <h4 className="text--primary">ماذا تريد ؟</h4>
            <ul className="chat-box__bot" onClick={handleOption}>
              <li
                className="menu-btn__item chat-box__bot-option"
                onClick={() => setSelectOption("service")}
              >
                طلب خدمة
              </li>
              <li
                className="menu-btn__item chat-box__bot-option"
                onClick={() => setSelectOption("help")}
              >
                {" "}
                طلب مساعدة{" "}
              </li>
            </ul>
          </p>
          <p className="text--gray">4:15</p>
        </div>
        {selectOption === "طلب خدمة" && (
          <div className="row-flex">
            <div className="message__box-img">
              <img src={Logo} alt="" className="chat-box__img" />
            </div>
            <p className="chat-box__text">
              <h4 className="text--primary"> نوع الخدمة ؟</h4>
              <ul className="chat-box__bot">
                <li
                  className="menu-btn__item chat-box__bot-option"
                  onClick={handleOption}
                >
                  {" "}
                  خدمات العمالة المنزلية{" "}
                </li>
                <li
                  className="menu-btn__item chat-box__bot-option"
                  onClick={handleOption}
                >
                  {" "}
                  خدمات توصيل عامة{" "}
                </li>
                <li
                  className="menu-btn__item chat-box__bot-option"
                  onClick={handleOption}
                >
                  {" "}
                  خدمات لوجستية{" "}
                </li>
              </ul>
            </p>
            <p className="text--gray">4:15</p>
          </div>
        )}
        {selectOption && (
          <div className="row-flex-reverse">
            <div className="message__box-img">
              <img src={Logo} alt="" className="chat-box__img" />
            </div>
            <p className="chat-box__text-second"> {selectOption} </p>
            <p className="text--gray">4:15</p>
          </div>
        )}
      </div>
    </div>
  );
};
const ContactInfo = () => {
  return (
    <div className="support__contact-info">
      <div className="contact-info__details">
        <div className="message__box-img contact-info__details__box">
          <img src={Pic} alt="" className="message__img" />
          <div className="contact-info__details__active"></div>
        </div>
        <HeadTitle title="عبد الله احمد" small={true} />
        <p className="text--small">كود الكفيل : HS12354</p>
        <Link to="/profile-guarantor">
          <p className="text--primary">
            <u> مشاهدة الملف الشخصي</u>
          </p>
        </Link>
      </div>
      <div className="contact-info__data">
        <HeadTitle title="المعلومات الاساسية" small={true} />
        <div className="contact-info__item row-flex">
          <PhoneIcon />
          <p>+96556286482</p>
        </div>

        <div className="contact-info__item row-flex">
          <EnvloIcon />
          <p>Example@example.com</p>
        </div>
        <div className="contact-info__item row-flex">
          <LocationIcon />
          <p>ش الرئيسي , الكويت</p>
        </div>
      </div>
      <BlockBtn />
    </div>
  );
};

export default Chat;

const MessagesContainer = () => {
  return (
    <div className="message__container">
      {Array(10)
        .fill(0)
        .map((item) => (
          <MessageItem />
        ))}
    </div>
  );
};

const MessageItem = () => {
  return (
    <div className="message__box">
      <div className="row-flex">
        <div className="message__box-img">
          <img src={Pic} alt="" className="message__img" />
        </div>
        <div className="message__box-text">
          <div className="message__box-name">
            {" "}
            <h3 className="ternary__heading ternary__heading--small">
              فهد آل راجح
            </h3>
          </div>
          <p className="text--small">نعم يناسبني هذا الموعد 👍💖</p>
        </div>
      </div>

      <div className="message__box-content">
        <p className="text--primary message__box-time">PM 2:34</p>
        <p className="message__box-count ">3</p>
      </div>
    </div>
  );
};
